/**
 * Resets the Design System with the provided object.
 * @param {object} obj - Object to reset the Design System with.
 * @param {object} [opts={}] - Options for resetting the Design System.
 */
export function getConfig() {
  const { environment } = this.sdk
  return { apiUrl: environment.apiUrl }
}
